import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import styled, { useTheme } from 'styled-components';
import { Checkbox } from 'components/Form/Checkbox';
import { DatePicker } from 'components/Form/DatePicker';
import { Input } from 'components/Form/Input';
import Icon from 'components/Icon';
import Spacer from 'components/Spacer';
import { ResponsiveCol, ResponsiveRow } from '../../AddEvents/styles';
import { TieredPricing } from './TieredPricing';

const InputWrapper = styled.div`
  margin-top: 10px;
`;

export const TicketMoreDetail = ({
  handleChange,
  ticket,
  index,
  ticketType,
  errors,
  isMobile,
}) => {
  const theme = useTheme();

  const [ticketLimit, setTicketLimit] = useState(false);
  const [highlightedTicket, setHighlightedTicket] = useState(false);
  const [reservedSeat, setReservedSeat] = useState(false);
  const [salesWindow, setSalesWindow] = useState(false);
  const [ticketTiers, setTicketTiers] = useState(false);
  const [access_code, setAccessCode] = useState(false);

  const [viewMore, setViewMore] = useState(false);

  useEffect(() => {
    if (ticket.is_featured) setHighlightedTicket(true);
    if (ticket.limit) setTicketLimit(true);
    if (ticket.reserved_seat) setReservedSeat(true);
    if (ticket.sale_start || ticket.sale_end) setSalesWindow(true);
    if (ticket.ticket_tiers && ticket.ticket_tiers.length > 0) {
      setTicketTiers(true);
    }
    if (ticket.code || ticket.code_date || ticket.code_time) {
      setAccessCode(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    ticket.is_featured,
    ticket.limit,
    ticket.reserved_seat,
    ticket.sale_start,
    ticket.sale_end,
    ticket.ticket_tiers,
  ]);

  return (
    <ResponsiveRow>
      <ResponsiveCol style={{ flex: !isMobile ? '0 0 70%' : '0 0 100%' }}>
        <ResponsiveRow>
          <div
            style={{
              paddingBottom: 10,
              paddingLeft: 10,
              margin: '10px 0px',
              marginLeft: 5,
              cursor: 'pointer',
              color: `${theme.colors.primary}`,
              display: 'flex',
              flexDirection: 'row',
            }}
            onClick={() => setViewMore(!viewMore)}
            role="presentation"
          >
            {viewMore ? 'View Less' : 'View More'}
            <div
              style={{
                marginLeft: 5,
                transform: `rotate(${viewMore ? -180 : 0}deg)`,
                transition: 'transform 0.5s ease',
              }}
            >
              <Icon icon="chevron" size={14} color={theme.colors.primary} />
            </div>
          </div>
        </ResponsiveRow>
        {viewMore && (
          <>
            <ResponsiveRow>
              <ResponsiveCol>
                <Checkbox
                  name="sales_window"
                  className="sales_window"
                  checked={salesWindow}
                  onChange={(event) => {
                    const value = event.target?.checked;

                    setSalesWindow(value);

                    handleChange({
                      target: {
                        name: `sales_window`,
                        value,
                      },
                    });
                  }}
                  rightText="Sales Window"
                />
              </ResponsiveCol>
            </ResponsiveRow>
            {salesWindow && (
              <>
                <Spacer size={10} />
                <ResponsiveRow>
                  <ResponsiveCol>
                    <DatePicker
                      id="sale_start"
                      name="sale_start"
                      label="Ticket Sales Start"
                      type="date"
                      test
                      onChange={(_, value) => {
                        handleChange({
                          target: { name: 'sale_start', value },
                        });
                        errors[`${ticketType}.${index}.sale_start`] = '';
                      }}
                      value={ticket.sale_start}
                      error={errors.sale_start}
                      isResponsive={true}
                    />
                  </ResponsiveCol>
                  <ResponsiveCol>
                    <div
                      onClick={
                        ticket.sale_start === ''
                          ? () =>
                              toast.error(
                                'Ticket sales start date is not selected'
                              )
                          : null
                      }
                      role="presentation"
                    >
                      <DatePicker
                        id="sale_end"
                        name="sale_end"
                        label="Ticket Sales End"
                        type="date"
                        onChange={(_, value) => {
                          handleChange({
                            target: { name: 'sale_end', value },
                          });
                          errors[`${ticketType}.${index}.sale_end`] = '';
                        }}
                        value={ticket.sale_end}
                        error={errors.sale_end}
                        disabled={ticket.sale_end === '' ? true : false}
                        isResponsive={true}
                      />
                    </div>
                  </ResponsiveCol>
                </ResponsiveRow>
                <ResponsiveRow style={{ marginTop: 30 }}>
                  <ResponsiveCol>
                    <DatePicker
                      id={'on_sale_time'}
                      type="time"
                      label={`Ticket on Sale Time`}
                      name="on_sale_time"
                      value={ticket.on_sale_time}
                      onChange={(name, event) => {
                        handleChange({
                          target: {
                            name,
                            value: event.target.value,
                          },
                        });
                      }}
                      isResponsive={true}
                    />
                  </ResponsiveCol>
                  <ResponsiveCol>
                    <DatePicker
                      id={'off_sale_time'}
                      type="time"
                      label={`Ticket Off Sale Time`}
                      name="off_sale_time"
                      value={ticket.off_sale_time}
                      onChange={(name, event) => {
                        handleChange({
                          target: {
                            name,
                            value: event.target.value,
                          },
                        });
                      }}
                      isResponsive={true}
                    />
                  </ResponsiveCol>
                </ResponsiveRow>
              </>
            )}

            <Spacer size={15} />

            <ResponsiveRow>
              <ResponsiveCol>
                <Checkbox
                  name="is_featured"
                  className="highlighted"
                  checked={highlightedTicket}
                  onChange={(event) => {
                    const value = event.target?.checked;
                    setHighlightedTicket(value);
                    handleChange({
                      target: {
                        name: 'is_featured',
                        value,
                      },
                    });
                  }}
                  rightText="Display Highlighted Ticket"
                />
              </ResponsiveCol>
            </ResponsiveRow>

            {highlightedTicket && (
              <>
                <Spacer size={10} />
                <ResponsiveRow>
                  <ResponsiveCol>
                    <Input
                      id={`${ticketType}.${index}.featured_text`}
                      name={`${ticketType}.${index}.featured_text`}
                      label="Highlighted Ticket Name"
                      type="text"
                      placeholder=""
                      onChange={({ target }) =>
                        handleChange({
                          target: {
                            name: `featured_text`,
                            value: target.value,
                          },
                        })
                      }
                      value={ticket.featured_text ?? ''}
                    />
                  </ResponsiveCol>
                </ResponsiveRow>
              </>
            )}

            <Spacer size={15} />

            <ResponsiveRow>
              <ResponsiveCol>
                <Checkbox
                  name="ticket_limit"
                  className="ticket_limit"
                  checked={ticketLimit}
                  onChange={(event) => {
                    const value = event.target?.checked;

                    setTicketLimit(value);
                    if (!value)
                      handleChange({
                        target: {
                          name: `limit`,
                          value: null,
                        },
                      });
                  }}
                  rightText="Ticket Limit"
                />
              </ResponsiveCol>
            </ResponsiveRow>
            <ResponsiveRow>
              <ResponsiveCol>
                {ticketLimit && (
                  <InputWrapper>
                    <Input
                      style={{ marginRight: '15px' }}
                      id={`${ticketType}.${index}.limit`}
                      name={`${ticketType}.${index}.limit`}
                      label="Limit"
                      type="text"
                      placeholder=""
                      onChange={({ target }) =>
                        handleChange({
                          target: {
                            name: `limit`,
                            value: parseInt(target.value),
                          },
                        })
                      }
                      value={ticket.limit ?? ''}
                    />
                  </InputWrapper>
                )}
              </ResponsiveCol>
            </ResponsiveRow>

            <Spacer size={15} />

            <TieredPricing
              ticketTiers={ticketTiers}
              setTicketTiers={setTicketTiers}
              handleChange={handleChange}
              ticket_tiers={
                ticket.ticket_tiers?.length > 0
                  ? ticket.ticket_tiers
                  : [
                      {
                        label: '',
                        price: '',
                        track_price: '',
                        color_code: '',
                      },
                    ]
              }
            />

            <Spacer size={15} />

            <ResponsiveRow>
              <ResponsiveCol>
                <Checkbox
                  name="reserved_seat"
                  className="reserved_seat"
                  checked={reservedSeat}
                  onChange={(event) => {
                    const value = event.target?.checked;
                    setReservedSeat(value);
                    handleChange({
                      target: {
                        name: 'reserved_seat',
                        value,
                      },
                    });
                  }}
                  rightText="Reserved Seat"
                />
              </ResponsiveCol>
            </ResponsiveRow>
            {reservedSeat && (
              <>
                <ResponsiveRow>
                  <ResponsiveCol>
                    <InputWrapper>
                      <Input
                        style={{ marginRight: '15px' }}
                        id={`${ticketType}.${index}.reserved_seat_category`}
                        name={`${ticketType}.${index}.reserved_seat_category`}
                        label="Seats.io Category"
                        type="text"
                        placeholder=""
                        onChange={({ target }) =>
                          handleChange({
                            target: {
                              name: `reserved_seat_category`,
                              value: target.value,
                            },
                          })
                        }
                        value={ticket.reserved_seat_category ?? ''}
                      />
                    </InputWrapper>
                  </ResponsiveCol>
                  <ResponsiveCol>
                    <InputWrapper>
                      <Input
                        style={{ marginRight: '15px' }}
                        id={`${ticketType}.${index}.reserved_seat_prefix`}
                        name={`${ticketType}.${index}.reserved_seat_prefix`}
                        label="Ticket Prefix"
                        type="text"
                        placeholder=""
                        onChange={({ target }) =>
                          handleChange({
                            target: {
                              name: `reserved_seat_prefix`,
                              value: target.value,
                            },
                          })
                        }
                        value={ticket.reserved_seat_prefix ?? ''}
                      />
                    </InputWrapper>
                  </ResponsiveCol>
                </ResponsiveRow>
                <Spacer size={10} />
                <ResponsiveRow>
                  <ResponsiveCol>
                    <Checkbox
                      myStyle={{
                        marginBottom: '20px',
                        marginRight: '15px',
                        display: 'inline-block',
                      }}
                      name="reserved_seat_section"
                      className="reserved_seat_section"
                      checked={ticket.reserved_seat_section}
                      onChange={(event) => {
                        const value = event.target?.checked;
                        handleChange({
                          target: {
                            name: 'reserved_seat_section',
                            value,
                          },
                        });
                      }}
                      rightText="Show as Section/Row/Seat"
                    />
                  </ResponsiveCol>
                </ResponsiveRow>
              </>
            )}

            <Spacer size={15} />

            <ResponsiveRow>
              <ResponsiveCol>
                <Checkbox
                  name="access_code"
                  checked={access_code}
                  onChange={(event) => {
                    const value = event.target?.checked;

                    setAccessCode(value);

                    handleChange({
                      target: {
                        name: `access_code`,
                        value: value,
                      },
                    });
                  }}
                  error={errors.access_code && errors.access_code}
                  rightText="Set Access Code"
                />
              </ResponsiveCol>
            </ResponsiveRow>
            {access_code && (
              <>
                <Spacer size={10} />
                <ResponsiveRow>
                  <ResponsiveCol>
                    <Input
                      id={`${ticketType}.${index}.code`}
                      name={`${ticketType}.${index}.code`}
                      label="Access Code"
                      placeholder="Code"
                      onChange={({ target }) =>
                        handleChange({
                          target: {
                            name: `code`,
                            value: target.value,
                          },
                        })
                      }
                      value={ticket.code}
                      error={errors.code && errors.code}
                    />
                  </ResponsiveCol>
                  <ResponsiveCol></ResponsiveCol>
                </ResponsiveRow>
                <ResponsiveRow style={{ marginTop: 30 }}>
                  <ResponsiveCol>
                    <DatePicker
                      id="code_date"
                      name="code_date"
                      label="End Date"
                      type="date"
                      onChange={(_, value) => {
                        handleChange({
                          target: { name: 'code_date', value },
                        });
                        errors[`${ticketType}.${index}.code_date`] = '';
                      }}
                      value={ticket.code_date}
                      error={errors.code_date}
                      disabled={ticket.code_date === '' ? true : false}
                      isResponsive={true}
                    />
                  </ResponsiveCol>
                  <ResponsiveCol>
                    <DatePicker
                      id={'code_time'}
                      type="time"
                      label={`End Time`}
                      name="code_time"
                      value={ticket.code_time}
                      onChange={(name, event) => {
                        handleChange({
                          target: {
                            name,
                            value: event.target.value,
                          },
                        });
                      }}
                      isResponsive={true}
                    />
                  </ResponsiveCol>
                </ResponsiveRow>
              </>
            )}
          </>
        )}
      </ResponsiveCol>
    </ResponsiveRow>
  );
};
